import React, { useMemo, useEffect, useState } from 'react'
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';
import { __remove, __set } from 'src/store/axios_indicator';
import { AgGridReact } from 'ag-grid-react';
import { useAdminBOMStore } from 'src/hooks/admin/adminBom';
import Admin from "@system/config/admin";
import moment from "moment";

const BOMManagementList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ filter_list }, { }, { }] = useAdminAccountFilterStore();
  const [gridApi, setGridApi] = useState(null);
  const gridRef = React.useRef();
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [{ bomList: rowData, message }, { }, { }] = useAdminBOMStore();

  const loadBomId = (e) => {
    return <>
      <a href={Admin.getAdminBOMDetailURL() + '?bomId=' + e.value} className='' target="_blank"> {e.value}</a>
    </>
  }
  const dateModifier = (e) => {
    return moment(e.value).format('MM/DD/YYYY')
  }
  const [columnDefs, setColumnDefs] = useState([
    { field: 'id', headerName: 'BOM ID', headerTooltip: 'BOM ID', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150, cellRenderer: loadBomId, },
    { field: 'name', headerName: 'BOM NAME', headerTooltip: 'BOM NAME', sortable: true, comparator: Helper.textSortingAgGrid, minWidth: 150 },
    {
      field: 'createdDate',
      headerName: 'CREATED DATE',
      headerTooltip: 'CREATED DATE',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      },
      minWidth: 150,
      cellRenderer: dateModifier
    },
    {
      field: 'updatedDate',
      headerName: 'LAST UPDATED',
      headerTooltip: 'LAST UPDATED',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      },
      minWidth: 150,
      cellRenderer: dateModifier
    }
  ]);

  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    // params.api.addEventListener('columnResized', onColumnResided);
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onExportAll = async () => {
    const allColumnState = gridColumnApi.getColumnState();
    const customColumns = allColumnState
      .filter((column) => column.hide !== true && column.colId != '0')
      .map((column) => column.colId);
    let params = { fileName: `bom_list.xlsx`, sheetName: "bom_list", columnKeys: customColumns };
    gridRef.current.api.exportDataAsExcel(params);
  }

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      // lockPinned: true,
      resizable: true
    };
  }, []);

  return (
    <div>
      <div className='bg-black p-2 export-list d-flex align-items-center justify-content-between'>
        <div className='d-flex align-items-center'></div>
        {rowData[0]?.id &&
          <span id="emailFilter" className="dropdown me-2">
            <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white' onClick={onExportAll}>
              <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
            </a>
          </span>
        }
      </div>

      {rowData[0]?.id && <div className="ag-theme-alpine ag-grd-hg mb-5">
        <AgGridReact
          rowData={rowData}
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          suppressRowClickSelection={true}
          onGridReady={onGridReady}
          autoGroupColumnDef={{
            headerName: 'Group',
            minWidth: 220,
          }}
        >
        </AgGridReact>
      </div>}
      {message?.trim()?.length > 0 &&
        <div className='container mt-3 mb-3'>
          <div className="alert alert-info fade in font-16 mb-2 text-center">
            <span>{message}</span>
          </div></div>}

    </div>
  )
}

export default BOMManagementList
